import { fromJS } from "immutable"
import {
  GET_TEMPLATE_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isDownloading: false,
  isUploading: false,
})

function ambassadorsImportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATE_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_FAILED:
      return state.set("isDownloading", false)

    case UPLOAD_TEMPLATE_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_SUCCESS:
      return state.set("isUploading", false)
    case UPLOAD_TEMPLATE_FAILED:
      return state.set("isUploading", false)

    default:
      return state
  }
}

export default ambassadorsImportReducer
